import comp from "./AssessmentIcon";
export default comp;
